import { render, staticRenderFns } from "./EmissionSourceComparativeScenarioForm.vue?vue&type=template&id=966d805c&scoped=true"
import script from "./EmissionSourceComparativeScenarioForm.vue?vue&type=script&lang=ts"
export * from "./EmissionSourceComparativeScenarioForm.vue?vue&type=script&lang=ts"
import style0 from "./EmissionSourceComparativeScenarioForm.vue?vue&type=style&index=0&id=966d805c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966d805c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxSectionTitle: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/SectionTitle.vue').default,IxSectionText: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/SectionText.vue').default,IxTextField: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/TextField.vue').default,IxTextarea: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/Textarea.vue').default,IxButtonAction: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/button/Action.vue').default,IxSection: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/Section.vue').default})
